// extracted by mini-css-extract-plugin
export default {"inputContainer":"CustomInput_inputContainer__53F9q","label":"CustomInput_label__3H1Uy","error":"CustomInput_error__v6nV4","input":"CustomInput_input__jvwsu"};